var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TablePortlet',{ref:"portlet",attrs:{"code":"clientTripsPortlet","title":"Trechos criados recentemente","fetcher":_vm.fetchData,"spec":_vm.spec},on:{"rowClicked":_vm.showRowDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }